import { configureStore } from "@reduxjs/toolkit";
import loggedInUser from "../auth/authSlice";
const store = configureStore({
    reducer: {
        loggedInUser,
    },
});

export default store;
